
import React, { memo, useState, useEffect } from "react";

import { getWebEnvObj } from "@/utils";
import { HomeOssUrl as CDN_URL} from "@/components/Home/utils"
import styles from './style.module.less';

const Empty = ({ desc = "暂无内容", image = `${CDN_URL}/noData.png`, style = {} }) =>
(
  <div className={styles.empty_wrap} style={style}>
    <img className={styles.image} src={image} />
    <div className={styles.desc}>{desc}</div>
  </div>
)
export default Empty
